import { useState } from "react"

import Chevron from "@/assets/svg/advisor-inner/chevron.svg?react"
import { cn } from "@/lib/utils"

import type { AdvisorFaq as Faq } from "../config/advisor-inner"

interface AdvisorFaqListProps {
  faqs: Faq[]
}

/** Accordion list of FAQs. Ported from the MUI Accordion in AdvisorsInner. */
export function AdvisorFaqList({ faqs }: AdvisorFaqListProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div data-slot="advisor-faq" className="mt-4 flex flex-col gap-2">
      {faqs.map((item, index) => {
        const open = openIndex === index
        return (
          <div key={item.question} className="rounded-xl bg-purple-light/10 p-1">
            <button
              type="button"
              onClick={() => setOpenIndex(open ? null : index)}
              className="flex w-full items-center justify-between gap-2 p-3 text-left"
            >
              <span className="font-body text-base text-purple-light">{item.question}</span>
              <span
                className={cn("shrink-0 transition-transform [&_svg]:size-6", open && "rotate-180")}
              >
                <Chevron />
              </span>
            </button>
            {open && (
              <p className="px-3 pb-3 font-body text-base text-purple-light/70">{item.answer}</p>
            )}
          </div>
        )
      })}
    </div>
  )
}
